import React, { useContext, useState, useEffect } from 'react';
import Modal from 'react-modal';
import './StatiModal.scss';
import { StateStore } from '../store';
import fire from '../base';
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import Loading from './Loading';
import { names } from '../Data';

export default function StatiModal({ modalIsOpen, toggle }) {
  const { state: { preferences, user } } = useContext(StateStore);
  // const today = new Date();
  // const otherDay = new Date();
  // otherDay.setDate(today.getDate() - 6);
  const [range, setRange] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);
  const [queryResults, setQueryResults] = useState(null);

  useEffect(() => {
    if (range)
      rangeUpdated();
  }, [range]);

  const rangeUpdated = param => {
    setIsFetching(true);
    setError(null);

    fire.firestore()
      .collection('users')
      .doc(user.uid)
      .collection('stati')
      .where("unixTimestamp", ">=", range[0].getTime())
      .where("unixTimestamp", "<=", range[1].getTime())
      .get().then(resp => {
        const data = resp.docs.map(doc => doc.data());
        setIsFetching(false);
        if (data.length === 0) {
          setError("There are no records in this range of dates");
          setQueryResults(null);
          return
        }
        setQueryResults(data);
      }).catch(e => { console.log(e); setIsFetching(false); setQueryResults(null); setError(e.message) });
  }
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => toggle(false)}
        className={"modal stati-modal " + preferences.theme}
        overlayClassName="modal-overlay stati-modal-overlay"
      >
        <div className="heading">Select History Range</div>
        <div className="slctHolder">
          <DateRangePicker onChange={setRange} value={range} />
        </div>
        {isFetching ? <><div className="spacer"></div><Loading bright={preferences.theme === 'dark'}></Loading></> : null}
        {error ? <><div className="spacer"></div><div className="m error">{error}</div></> : null}
        {queryResults ? <div className="dataDisplay">
          <span></span>
          {names.map(name => (<span key={name}>{name}</span>))}
          {queryResults.map(stati => (
            <>
              <span style={{ textAlign: "left" }}>{new Date(stati.unixTimestamp).toDateString()}</span>
              <span className={"status " + stati.Fajr}></span>
              <span className={"status " + stati.Zuhr}></span>
              <span className={"status " + stati.Asr}></span>
              <span className={"status " + stati.Maghrib}></span>
              <span className={"status " + stati.Isha}></span>
            </>
          ))}
        </div> : null}
      </Modal>
    </div>
  )
}

Modal.setAppElement('body');